import { type StreamForDashboard } from 'Lessons';
import { type StreamProgress } from './ContentProgress.types';

type GetMsLeftInTimeLimitArgs = {
    stream: StreamForDashboard | null | undefined;
    streamProgress: StreamProgress | null | undefined;
};

const HOUR_IN_MILLISECONDS = 60 * 60 * 1000;

const getMsLeftFromProgress = (streamProgress?: StreamProgress | null): number | null => {
    const timeRunsOutAt = streamProgress?.timeRunsOutAt ?? null;
    if (timeRunsOutAt === null) {
        return null;
    }

    const msUntilExpiration = timeRunsOutAt * 1000 - Date.now();
    return Math.max(0, msUntilExpiration);
};

const getTimeLimitHours = (stream?: StreamForDashboard | null): number | null => {
    if (!stream) {
        return null;
    }

    const streamWithTimeLimit = stream as StreamForDashboard & {
        timeLimitHours?: number | null;
        time_limit_hours?: number | null;
    };

    const timeLimitHours = streamWithTimeLimit.timeLimitHours ?? streamWithTimeLimit.time_limit_hours ?? null;
    if (typeof timeLimitHours !== 'number') {
        return null;
    }

    return timeLimitHours;
};

export const getMsLeftInTimeLimit = ({ stream, streamProgress }: GetMsLeftInTimeLimitArgs): number | null => {
    const msFromProgress = getMsLeftFromProgress(streamProgress);
    if (msFromProgress !== null) {
        return msFromProgress;
    }

    const timeLimitHours = getTimeLimitHours(stream);
    if (timeLimitHours === null) {
        return null;
    }

    return timeLimitHours * HOUR_IN_MILLISECONDS;
};
